// An interaction (such as a button click or a form submission) in our React components will fire off an action and, in turn, dispatch an action to our store.

export const GET_ERRORS = "GET_ERRORS";
export const USER_LOADING = "USER_LOADING";
export const SET_CURRENT_USER = "SET_CURRENT_USER";